import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {DisplayedSizeScale, SizeScaleRequestDto} from "app/models/menu.model";
import {environment} from "environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SizeScaleService {

  private requestPath = `${environment.posBaseUrl}/api/front/size-scale`;

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  constructor(
    private http: HttpClient,
  ) { }

  public createSizeScale(sizeScale: SizeScaleRequestDto) : Observable<DisplayedSizeScale>{
    return this.http.post<DisplayedSizeScale>(
      this.requestPath,
      sizeScale,
      {
      headers: this.headers,
    });
  }

  public updateSizeScale(sizeScaleId: string, sizeScale: SizeScaleRequestDto) : Observable<DisplayedSizeScale>{
    return this.http.put<DisplayedSizeScale>(
      `${this.requestPath}/${sizeScaleId}`,
      sizeScale,
      {
      headers: this.headers,
    });
  }

  public deleteSizeScale(organizationId: string, sizeScaleId: string) : Observable<any> {
    return this.http.delete(`${this.requestPath}/${sizeScaleId}/organization/${organizationId}`);
  }

  public canDeleteSizeScale(menuSectionId: string, sizeScaleId: string) : Observable<string[]>{
    return this.http.get<string[]>(`${this.requestPath}/can-delete/${menuSectionId}/${sizeScaleId}`);
  }
}
